import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { CalculatorSection } from "@app/components/calculator";
import { SideImage } from "./components/side-image/SideImage";

export const CostCalculator = () => {
  const { t } = useTranslation("p_investment_cost-calculator");

  return (
    <>
      <div
        className={classNames(
          "mb-20 mt-40 px-5",
          "md:mb-25 md:px-15",
          "lg:mt-60",
          "xl:mb-40 xl:px-24",
        )}
      >
        <div
          className={classNames(
            "mx-auto flex max-w-container flex-col gap-20",
            "md:gap-25",
            "xl:gap-40",
          )}
        >
          <div className={classNames("md:text-center")}>
            <div className="flex justify-center">
              <div className="md:w-8/12">
                <h1
                  className={classNames(
                    "mb-5 text-large text-primary-content",
                    "md:text-xx-large",
                    "xl:text-huge",
                  )}
                >
                  {t("hero_title")}
                </h1>
                <p
                  className={classNames(
                    "text-regular text-base-400",
                    "md:text-medium",
                  )}
                >
                  {t("section_1_body")}
                </p>
              </div>
            </div>
          </div>

          <CalculatorSection />
          <SideImage />
        </div>
      </div>
    </>
  );
};
